module.exports = __webpack_public_path__ + "static/online-program-music-world-wide-00ea0ba567f72bacf42b1a99be600cc1.png";